import { useTheme } from '@mui/material';

export default function EmbedWebLeftIcon({
  isSelected,
  buttonBgColor = '#fff',
  buttonColor = '#000'
}: {
  isSelected?: boolean;
  buttonBgColor?: string;
  buttonColor?: string;
}) {
  const theme = useTheme();
  return (
    <svg width='252' height='180' viewBox='0 0 252 180' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.5' y='0.5' width='250.333' height='179' rx='7.5' fill='#ECECEC' />
      {isSelected && <rect x='0.5' y='0.5' width='250.333' height='179' rx='7.5' stroke={theme.palette.primary.main} />}
      <path
        d='M22.6662 25.5043C24.2337 25.5043 25.5043 24.2337 25.5043 22.6662C25.5043 21.0988 24.2337 19.8281 22.6662 19.8281C21.0988 19.8281 19.8281 21.0988 19.8281 22.6662C19.8281 24.2337 21.0988 25.5043 22.6662 25.5043Z'
        fill='#EF4444'
      />
      <path
        d='M31.6506 25.5043C33.218 25.5043 34.4887 24.2337 34.4887 22.6662C34.4887 21.0988 33.218 19.8281 31.6506 19.8281C30.0832 19.8281 28.8125 21.0988 28.8125 22.6662C28.8125 24.2337 30.0832 25.5043 31.6506 25.5043Z'
        fill='#FCD34D'
      />
      <path
        d='M40.6272 25.5043C42.1946 25.5043 43.4653 24.2337 43.4653 22.6662C43.4653 21.0988 42.1946 19.8281 40.6272 19.8281C39.0597 19.8281 37.7891 21.0988 37.7891 22.6662C37.7891 24.2337 39.0597 25.5043 40.6272 25.5043Z'
        fill='#83E83F'
      />
      <path
        d='M223.041 45.3281H28.2953C23.619 45.3281 19.8281 48.7541 19.8281 52.9803V81.6759C19.8281 85.9021 23.619 89.3281 28.2953 89.3281H223.041C227.717 89.3281 231.508 85.9021 231.508 81.6759V52.9803C231.508 48.7541 227.717 45.3281 223.041 45.3281Z'
        fill={theme.palette.primary.main}
      />
      <path
        d='M88.8887 95.9375H24.5583C21.9459 95.9375 19.8281 98.0553 19.8281 100.668V100.668C19.8281 103.28 21.9459 105.398 24.5583 105.398H88.8887C91.5011 105.398 93.6188 103.28 93.6188 100.668C93.6188 98.0553 91.5011 95.9375 88.8887 95.9375Z'
        fill={theme.palette.primary.main}
      />
      <rect x='19.8281' y='125.227' width='36.3492' height='36.3492' rx='18.1746' fill={buttonBgColor} />
      <path
        d='M38.0034 145.066C37.2338 145.066 36.5825 144.799 36.0494 144.266C35.5163 143.733 35.2497 143.081 35.2497 142.312V135.703C35.2497 134.933 35.5163 134.282 36.0494 133.749C36.5825 133.216 37.2338 132.949 38.0034 132.949C38.773 132.949 39.4244 133.216 39.9575 133.749C40.4906 134.282 40.7572 134.933 40.7572 135.703V142.312C40.7572 143.081 40.4906 143.733 39.9575 144.266C39.4244 144.799 38.773 145.066 38.0034 145.066ZM37.1773 153.051V149.421C35.3599 149.213 33.8499 148.434 32.6474 147.082C31.445 145.731 30.8438 144.141 30.8438 142.312H32.496C32.496 143.836 33.033 145.134 34.1069 146.208C35.1809 147.282 36.4797 147.819 38.0034 147.819C39.5271 147.819 40.826 147.282 41.8999 146.208C42.9739 145.134 43.5109 143.836 43.5109 142.312H45.1631C45.1631 144.141 44.5619 145.731 43.3595 147.082C42.157 148.434 40.647 149.213 38.8296 149.421V153.051H37.1773Z'
        fill={buttonColor}
      />
    </svg>
  );
}
